import { PageShell } from "@/components/PageShell";
import { LegalPage } from "@/components/LegalPage";

const Termos = () => {
  return (
    <PageShell>
      <LegalPage title="Termos de Uso" updated="7 de setembro de 2026">
        <h2>1. Sobre o site</h2>
        <p>
          rodeia.com.br é o site institucional da RODE IA LTDA, CNPJ
          68.764.921/0001-64.
        </p>
        <p>
          O conteúdo apresenta informações gerais sobre serviços de automação,
          integração de sistemas e tecnologia.
        </p>

        <h2>2. Contratação de serviços</h2>
        <p>
          A navegação no site não representa contratação automática de serviço.
        </p>
        <p>
          Escopo, responsabilidades, preços, prazos e condições comerciais são
          definidos separadamente em proposta, contrato ou instrumento
          aplicável.
        </p>

        <h2>3. Viabilidade técnica</h2>
        <p>
          A apresentação de possibilidades de automação ou integração não
          constitui garantia de que todo sistema, processo ou fornecedor possa
          ser integrado.
        </p>
        <p>
          A viabilidade depende de análise técnica, acessos disponíveis,
          permissões, APIs, dados, infraestrutura e demais condições do caso.
        </p>

        <h2>4. Conteúdo e propriedade intelectual</h2>
        <p>
          Textos, identidade visual, estrutura e demais conteúdos próprios da
          RODE IA não podem ser reproduzidos como material comercial de
          terceiros sem autorização, salvo usos permitidos por lei.
        </p>

        <h2>5. Serviços de terceiros</h2>
        <p>
          Algumas soluções podem depender de plataformas, APIs e serviços
          operados por terceiros, sujeitos aos respectivos termos,
          disponibilidade e políticas.
        </p>

        <h2>6. Disponibilidade</h2>
        <p>
          A RODE IA busca manter seus canais institucionais disponíveis, mas não
          garante funcionamento ininterrupto de serviços externos ou
          infraestruturas de terceiros.
        </p>

        <h2>7. Privacidade</h2>
        <p>
          O tratamento de dados pessoais é descrito em:{" "}
          <a href="/privacidade">https://rodeia.com.br/privacidade</a>.
        </p>

        <h2>8. Exclusão de dados</h2>
        <p>
          Instruções:{" "}
          <a href="/exclusao-de-dados">
            https://rodeia.com.br/exclusao-de-dados
          </a>
          .
        </p>

        <h2>9. Contato</h2>
        <p>
          <a href="mailto:contato@rodeia.com.br">contato@rodeia.com.br</a>
          <br />
          RODE IA LTDA
          <br />
          CNPJ 68.764.921/0001-64
        </p>
      </LegalPage>
    </PageShell>
  );
};

export default Termos;
